export const PROMO = "promo";
export const BANNER = "banner";
export const CONTENT = "content";
// export const NEW_CONTENT = 'newcontent';
export const ALL_DESTINATIONS = "alldestinations";
export const ALL_ROUTES = "allroutes";
export const LATEST_HERO = "latesthero";
export const HERO = "hero";
export const GALERY_V1 = "galeryv1";
export const GALERY_V2 = "galeryv2";
export const GALERY_V3 = "galeryv3";
export const GALERY_V4 = "galeryv4";
export const GALERY_V5 = "galeryv5";
export const GALERY_V6 = "galeryv6";
export const GALERY_V7 = "galeryv7";
export const TRAVELING = "traveling";
export const OPERATIONS = "operations";
export const NEWS = "news";
export const LATEST = "latest";
export const POPULAR = "popular";
export const STOPS = "stops";
export const CONTACTS = "contacts";
export const GIFT_CARD = "giftcard";
export const PROMOS = "promos";
export const REGISTRATION = "registration";
export const NEWS_LIST = "newslist";
export const STORY_LIST = "storylist";
export const IFRAME = "iframe";
export const LATESTLIST = "latestlist";
export const SUBSCRIPTION = "subscription";

export const blocks = [
  PROMO,
  BANNER,
  CONTENT,
  // NEW_CONTENT,
  ALL_DESTINATIONS,
  ALL_ROUTES,
  LATEST_HERO,
  HERO,
  GALERY_V1,
  GALERY_V2,
  GALERY_V3,
  GALERY_V4,
  GALERY_V5,
  GALERY_V6,
  GALERY_V7,
  TRAVELING,
  OPERATIONS,
  NEWS,
  LATEST,
  POPULAR,
  STOPS,
  CONTACTS,
  GIFT_CARD,
  PROMOS,
  REGISTRATION,
  NEWS_LIST,
  STORY_LIST,
  IFRAME,
  LATESTLIST,
  SUBSCRIPTION,
];

export default {
  PROMO,
  BANNER,
  CONTENT,
  ALL_DESTINATIONS,
  ALL_ROUTES,
  LATEST_HERO,
  HERO,
  GALERY_V1,
  GALERY_V2,
  GALERY_V3,
  GALERY_V4,
  GALERY_V5,
  GALERY_V6,
  GALERY_V7,
  TRAVELING,
  OPERATIONS,
  NEWS,
  LATEST,
  POPULAR,
  STOPS,
  CONTACTS,
  GIFT_CARD,
  PROMOS,
  REGISTRATION,
  NEWS_LIST,
  STORY_LIST,
  IFRAME,
  LATESTLIST,
  SUBSCRIPTION,
};
